import { ZValidation } from "models/common/validation";
import { HTMLInputTypeAttribute, InputHTMLAttributes } from "react";
import { ZTooltip } from "./ZTooltip";
import { ZIcon } from "./ZIcon";
import { ZIconType } from "helpers/utility/iconMap";
import { ZLabel } from "./ZLabel";

type ZTextInputProps = {
    value: string;
    label?: React.ReactNode | string;
    placeholder?: string;
    disabled?: boolean;
    type?: HTMLInputTypeAttribute;
    autoFocus?: boolean;
    id?: string;
    validation?: ZValidation;
    style?: React.CSSProperties;
    onChange?: (val: string) => void;
    onBlur?: () => void;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
};

export const ZTextInput = ({ value, label, placeholder, disabled, type, validation, autoFocus, id, style, onChange, onBlur, startAdornment, endAdornment }: ZTextInputProps) => {
    return (
        <div className="d-flex flex-column">
            <ZLabel preventSelect>{label}</ZLabel>
            <div className={`d-inline-flex p-1 ps-2 align-items-center rounded ztext-input${validation?.invalid ? ` invalid` : ``}${disabled ? ` disabled` : ``}`}>
                {startAdornment}
                <input id={id} autoFocus={autoFocus} autoComplete="off" style={style} className="ztext-input-inner p-0 flex-grow" value={value} onChange={(e) => onChange && onChange(e.target.value)} onBlur={() => { onBlur && onBlur(); onChange && onChange(value.trim());} } type={type} placeholder={placeholder} disabled={disabled} />
                {validation?.invalid &&
                    <ZTooltip
                        enabled
                        text={validation.error}
                    >
                        <ZIcon icon={ZIconType.Error} variant="danger" />
                    </ZTooltip>
                }
                {endAdornment}
            </div>
        </div>
    );
}